'use client';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Testimonial {
  id: number;
  name: string;
  location: string;
  service: string;
  rating: number;
  quote: string;
  image: string;
  alt: string;
  verified: boolean;
}

const QuoteTestimonials = () => {
  const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Oakwood Heights',
    service: 'Powerwashing',
    rating: 5,
    quote: 'The team did an incredible job powerwashing our driveway and siding. They were professional, punctual, and the results exceeded our expectations. Our home looks brand new!',
    image: "/assets/images/image-1769888281562.png",
    alt: 'Before and after comparison of power washing service showing dramatic transformation',
    verified: true
  },
  {
    id: 2,
    name: 'Michael Chen',
    location: 'Riverside District',
    service: 'Gutter Cleaning',
    rating: 5,
    quote: 'After years of neglect, our gutters were completely clogged. CrystalClean cleared everything out efficiently and even repaired a small leak. Outstanding service from start to finish.',
    image: "/assets/images/image-1769888845360.png",
    alt: 'Before and after comparison of gutter cleaning showing debris-filled gutters transformed to clean gutters',
    verified: true
  },
  {
    id: 3,
    name: 'Jennifer Martinez',
    location: 'Hillside Estates',
    service: 'Window Cleaning',
    rating: 5,
    quote: 'I was amazed at how much brighter our home felt after they cleaned all our windows. The attention to detail was impressive—they even cleaned the tracks and screens. Highly recommend!',
    image: "/assets/images/image-1769889700705.png",
    alt: 'Before and after comparison of professional window cleaning showing Crystal Clean transformation',
    verified: true
  },
  {
    id: 4,
    name: 'Robert Thompson',
    location: 'Maple Grove',
    service: 'Roof Cleaning',
    rating: 5,
    quote: 'Our roof had years of moss and algae buildup. The team used a gentle soft-wash method that removed everything without damaging the shingles. The transformation is remarkable.',
    image: "/assets/images/image-1769890239104.png",
    alt: 'Before and after comparison of roof cleaning showing moss and algae removal transformation',
    verified: true
  }];


  return (
    <div className="bg-surface border border-border rounded-lg p-8">
      <div className="text-center mb-8">
        <h3 className="font-serif text-2xl font-semibold text-foreground mb-2">
          What Our Customers Say
        </h3>
        <p className="text-muted-foreground">
          Real reviews from satisfied homeowners in your area
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((testimonial) =>
        <div
          key={testimonial.id}
          className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-brand transition-smooth">

            <div className="relative h-48 w-full">
              <AppImage
              src={testimonial.image}
              alt={testimonial.alt}
              className="w-full h-full object-cover" />

              {testimonial.verified &&
            <div className="absolute top-3 right-3 bg-primary text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center space-x-1">
                  <Icon name="CheckBadgeIcon" size={14} />
                  <span>Verified</span>
                </div>
            }
            </div>

            <div className="p-6">
              <div className="flex items-center mb-3">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Icon key={i} name="StarIcon" size={16} className="text-yellow-400 fill-current" />
              )}
              </div>

              <p className="text-sm text-muted-foreground mb-4 italic">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div>
                  <p className="font-semibold text-foreground text-sm">{testimonial.name}</p>
                </div>
                <div className="text-right">
                  <p className="text-xs font-medium text-primary">{testimonial.service}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="mt-8 bg-accent border border-primary/20 rounded-lg p-6 text-center">
        <div className="flex items-center justify-center space-x-8 mb-4">
          <div>
            <p className="font-serif text-3xl font-semibold text-primary">1000+</p>
            <p className="text-sm text-muted-foreground">Happy Customers</p>
          </div>
          <div className="h-12 w-px bg-border"></div>
          <div>
            <p className="font-serif text-3xl font-semibold text-primary">4.9/5</p>
            <p className="text-sm text-muted-foreground">Average Rating</p>
          </div>
          <div className="h-12 w-px bg-border"></div>
          <div>
            <p className="font-serif text-3xl font-semibold text-primary">100%</p>
            <p className="text-sm text-muted-foreground">Would Recommend</p>
          </div>
        </div>
        <p className="text-xs text-muted-foreground">
          Based on verified customer reviews from 2020-2025
        </p>
      </div>
    </div>);

};

export default QuoteTestimonials;